const menu= {

    filterData: {
        command: "filterData",
        text: "筛选",
        name: "filterData",
        iconClass: "gc-spread-custom-icon",
        workArea: "table"
    },

    filterCustom: {
        command: "filterCustom",
        text: "自定义...",
        name: "filterCustom",
        iconClass: "iconfont icon-autosave",
        workArea: "table"
    },
    filterBack: {
        command: "filterBack",
        text: "退回",
        name: "filterBack",
        iconClass: "gc-clearFilter",
        workArea: "table"
    },
    filterClear: {
        command: "filterClear",
        text: "撤销筛选",
        name: "filterClear",
        iconClass: "gc-clearFilter",
        workArea: "table"
    },
    filterAsc:{
        command:"filterAsc",
        iconClass:"gc-spread-sortAscend",
        name: "filterAsc",
        text:"升序",
        workArea:"table"
    },
    filterDesc:{

        command:"filterDesc",
        iconClass:"gc-spread-sortDescend",
        name: "filterDesc",
        text:"降序",
        workArea:"table"
    },
    tableInsert:{

        command:  "tableInsert",
        iconClass: "gc-spread-tableInsertRowsBelow",
        name: "tableInsert",
        text:"新增",
        workArea:"table"
    },
    tableDelete:{
        command:"tableDelete",
        iconClass:"gc-spread-tableDeleteRows",
        name: "tableDelete",
        text:"删除",
        workArea:"table"
    }
}
export default menu;